export const listLayoutTypes = {
    column: 'column',
    grid: 'grid',
};

export const headerLayoutModes = {
    default: 'default',
    mobileSticky: 'mobileSticky',
    doubleHeader: 'DoubleHeader',
};